<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {}
</script>
<style lang="scss">
@import './Common/base.css';
@import './Common/reset.css';
</style>
